import { create } from "zustand";
import { getStatus } from "src/api/google";

type GmailConnectorState = {
  isLoadingGmail: boolean;
  isGmailConnected: boolean;
  canSendGmail: boolean;
  refresh: () => Promise<void>;
  setStateFromServer: (p: { connected?: boolean; canSend?: boolean }) => void;
};

export const useGmailConnectorStore = create<GmailConnectorState>((set) => ({
  isLoadingGmail: true,
  isGmailConnected: false,
  canSendGmail: false,
  refresh: async () => {
    set({ isLoadingGmail: true });
    try {
      const r = await getStatus();
      set({
        isGmailConnected: !!r?.data?.connected,
        canSendGmail: !!r?.data?.canSend,
      });
    } catch {
      set({ isGmailConnected: false, canSendGmail: false });
    } finally {
      set({ isLoadingGmail: false });
    }
  },
  setStateFromServer: ({ connected, canSend }) =>
    set((s) => ({
      isGmailConnected:
        typeof connected === "boolean" ? connected : s.isGmailConnected,
      canSendGmail: typeof canSend === "boolean" ? canSend : s.canSendGmail,
    })),
}));
